import { PhoneCountryCodeType } from '@bus/models';
import { DirectorPersonFormModel_OB_OL } from './formModel';

export const getInitialValues = (): DirectorPersonFormModel_OB_OL => {
  return {
    title: undefined,
    firstName: '',
    middleName: '',
    lastName: '',
    gender: undefined,
    dateOfBirth: '',
    countryCode: PhoneCountryCodeType.Ireland,
    mobileNumber: '',
    email: '',
    residentialStatus: undefined,
  };
};
